import { BrowserRouter } from 'react-router-dom';
import Routing from './Routing';

function App() {
  return (
    <BrowserRouter>
      <Routing />
    </BrowserRouter>
  );
}

export default App;